import './setLang';

import React from 'react';
import ReactDOM from 'react-dom';
import './lib/polyfills';
import { App } from './blocks/App/App';

document.addEventListener('DOMContentLoaded', () => {
    ReactDOM.render(<App />, document.querySelector('#app'));
});
